<template>
    <v-container class="fill-height align-stretch justify-stretch">
        <div
            v-if="isLoading"
            class="text-center mt-6 flex-grow-1"
        >
            <v-progress-circular
                indeterminate
                color="primary"
                size="64"
            ></v-progress-circular>
        </div>

        <div
            v-else
            class="flex-grow-1 mb-12 mb-md-0"
        >
            <div v-if="video.storageTypeString != 'STORAGE_TYPE_KARSA'">
                Video tidak bisa diputar
            </div>

            <v-switch
                @change="changeHlsMode"
                v-model="isUsingHlsMode"
                label="Mode Apple"
                messages="Hanya aktifkan di perangkat Apple jika video tidak bisa diputar dan tidak ada pesan kesalahan"
                class="mb-2"
            ></v-switch>

            <v-alert
                v-if="error"
                class="text-left"
                type="error"
                text
                dense
            >
                Terjadi kesalahan, refresh, jika masih sama atau hubungi admin
                <div>
                    {{ error }}
                </div>
            </v-alert>

            <iframe
                width="100%"
                height="100%"
                :srcdoc="srcdoc"
                frameborder="0"
                allow="autoplay; fullscreen"
                allowfullscreen
            ></iframe>
        </div>
    </v-container>
</template>

<script>
import axios from 'axios'

export default {
    data: () => ({
        video: null,
        srcdoc: null,
        error: null,
        videoSeekDebounceTimeout: null,
        isUsingHlsMode: false,
        isLoading: true,
    }),

    methods: {
        changeHlsMode() {
            this.$nextTick(() => {
                localStorage.setItem(
                    'isUsingHlsMode',
                    JSON.stringify(this.isUsingHlsMode)
                )
                this.loadVideo()
            })
        },

        reportVideoErrorToMatomo(e) {
            const url = process.env.VUE_APP_BASE_URL
            if (e.origin !== url.substring(url, url.length - 1)) {
                return
            }

            switch (e.data?.type) {
                case 'playerError':
                    this.error = e.data.error
                    this.$tracking.event.video.error(e.data.error)
                    break
                case 'videoQualityChange':
                    this.$tracking.event.video.qualityChange(e.data.value)
                    break
                case 'videoPlay':
                    this.$tracking.event.video.play()
                    break
                case 'videoPause':
                    this.$tracking.event.video.pause()
                    break
                case 'videoSeek':
                    window.clearTimeout(this.videoSeekDebounceTimeout)
                    this.videoSeekDebounceTimeout = window.setTimeout(() => {
                        this.$tracking.event.video.seek(e.data.value)
                    }, 700)
                    break
                case 'videoVolume':
                    this.$tracking.event.video.volume(e.data.value)
                    break
                case 'videoFullscreen':
                    this.$tracking.event.video.fullscreen()
                    break
                case 'videoPIP':
                    this.$tracking.event.video.pip()
                    break
                case 'videoAirplay':
                    this.$tracking.event.video.airplay()
                    break
                case 'videoSpeed':
                    this.$tracking.event.video.speed(e.data.value)
                    break
            }
        },

        async loadVideo() {
            this.isLoading = true

            const hlsParameter = this.isUsingHlsMode ? '&forceHLS' : ''
            const response = await axios.get(
                `${process.env.VUE_APP_VIDEO_KARSA}${this.video.videoUrl}?autoplay${hlsParameter}`
            )
            this.srcdoc = response.data

            this.isLoading = false
        },
    },

    async created() {
        const response = await this.$apiv2.get(
            `user/period/kelon/video/${this.$route.params.hash}`,
            { loader: 'appbar' }
        )

        this.video = response.data
        const title = this.video.discussions
            .map((discussion) => discussion.title)
            .join(', ')
        this.$store.set('ui/title', title)

        if (this.video.storageTypeString != 'STORAGE_TYPE_KARSA') {
            return
        }

        window.addEventListener('message', this.reportVideoErrorToMatomo)
        const isUsingHlsMode = localStorage.getItem('isUsingHlsMode')
        this.isUsingHlsMode = JSON.parse(isUsingHlsMode)
        this.loadVideo()
    },

    beforeDestroy() {
        window.removeEventListener('message', this.reportVideoErrorToMatomo)
    },
}
</script>
